import { render, staticRenderFns } from "./loadMore.vue?vue&type=template&id=918d6642&scoped=true&"
import script from "./loadMore.vue?vue&type=script&lang=js&"
export * from "./loadMore.vue?vue&type=script&lang=js&"
import style0 from "./loadMore.vue?vue&type=style&index=0&id=918d6642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918d6642",
  null
  
)

export default component.exports